module.exports = __webpack_public_path__ + "static/media/unlock-badges.f7f60615.png";